import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Props } from 'src/features/@types/imageCard';

// ------------------------------------------------------------

export default function ImageCard({ url, title }: Props) {
  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardMedia
        component="img"
        alt={`imagem de ${title}`}
        image={url}
        style={{ width: '400px', height: '300px' }}
      />
      <CardContent>
        {title ? (
          <Typography gutterBottom variant="h5" component="div" align="center">
            {title}
          </Typography>
        ) : (
          ''
        )}
      </CardContent>
    </Card>
  );
}
